// Google Analytics 4 tracking utilities

const GA_MEASUREMENT_ID = 'G-NQ1S89HGCG'

// Initialize Google Analytics
export function initGA() {
  if (typeof window === 'undefined') return

  // Load gtag.js script
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  // Initialize gtag
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag
  
  gtag('js', new Date())
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: true,
    cookie_flags: 'SameSite=None;Secure'
  })

  console.log('✅ Google Analytics initialized:', GA_MEASUREMENT_ID)
}

// Track custom events
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams)
    console.log('📊 GA Event:', eventName, eventParams)
  }
}

// Track page views
export function trackPageView(pagePath, pageTitle) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle
    })
  }
}

// Demo-specific event tracking
export const DemoEvents = {
  // Map interactions
  mapLoaded: () => trackEvent('demo_map_loaded'),
  mapZoom: (zoomLevel) => trackEvent('demo_map_zoom', { zoom_level: zoomLevel }),
  
  // Legend interactions
  legendToggled: (isVisible) => trackEvent('demo_legend_toggled', { visible: isVisible }),
  legendDragged: () => trackEvent('demo_legend_dragged'),
  
  // Service level interactions
  serviceLevelChanged: (mode) => trackEvent('demo_service_level_changed', { mode }),
  heatmapToggled: (isVisible) => trackEvent('demo_heatmap_toggled', { visible: isVisible }),
  
  // Customer interactions
  customerClicked: (customerName) => trackEvent('demo_customer_clicked', { customer: customerName }),
  facilityClicked: (facilityName, facilityType) => trackEvent('demo_facility_clicked', { 
    facility: facilityName, 
    type: facilityType 
  }),
  
  // Lane interactions
  laneClicked: (origin, destination) => trackEvent('demo_lane_clicked', { 
    origin, 
    destination 
  }),
  
  // Filter interactions
  filterApplied: (filterType, value) => trackEvent('demo_filter_applied', { 
    filter_type: filterType, 
    value 
  }),
  
  // Session metrics
  demoSessionDuration: (seconds) => trackEvent('demo_session_duration', { 
    duration_seconds: seconds 
  })
}















